// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"454d8f65","447":"5af3cecd","624":"3e113f60","690":"8cac00dd","972":"dfa9ec23"}[chunkId] + ".chunk.css";
};